export const AnalyticsSlider = ({ label, value, min, max, step, onChange }) => (
    <div className="analytics-slider-control">
        <span className="analytics-slider-label">{ label }</span>
        <button className="analytics-slider-btn" onClick={ () => onChange(Math.max(min, value - step)) } disabled={ value <= min }>−</button>
        <input
            type="range"
            min={ min }
            max={ max }
            step={ step }
            value={ value }
            onChange={ e => onChange(Number(e.target.value)) }
            className="analytics-slider"
        />
        <button className="analytics-slider-btn" onClick={ () => onChange(Math.min(max, value + step)) } disabled={ value >= max }>+</button>
    </div>
)
